module.exports = __webpack_public_path__ + "img/icon-close.afe6b0c4.png";